import { render, staticRenderFns } from "./StdAlert.vue?vue&type=template&id=549801b0"
import script from "./StdAlert.vue?vue&type=script&lang=js"
export * from "./StdAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports